import SampleNextArrow from '@/components/SampleNextArrow';
import SamplePrevArrow from '@/components/SamplePrevArrow';
import { websiteEnv } from '@/constants/website-env';
import { generateUrl } from '@/util/imageUtils';
import Slider from 'react-slick';
import classes from './colorFilter.module.css';

const getStyle = item => {
  if (item.type === 'ColorSwatchData') {
    return {
      backgroundColor: item.rgb,
    };
  } else if (item.type === 'ImageSwatchData') {
    const imagePath = generateUrl(item.thumbnail, 'image-swatch')(50);

    return {
      display: 'block',
      height: '50px',
      width: '50px',
      backgroundSize: '100%',
      backgroundImage: `url("${imagePath}")`,
    };
  }

  return {};
};

const sliderProps = {
  dots: false,
  infinite: false,
  showArrows: false,
  slidesToShow: 12,
  arrows: true,
  nextArrow: <SampleNextArrow className={'nextarrow'} />,
  prevArrow: <SamplePrevArrow className={'prevarrow'} />,
  slidesToScroll: 6,
};

const ColorFilter = props => {
  const { colors, selectedColorIds, setSelectedColorIds } = props;

  return (
    <div className={classes.root}>
      <Slider {...sliderProps}>
        {colors.map((item, index) => {
          const itemClass = item.ids === selectedColorIds ? classes.activeItem : classes.item;

          return (
            <li
              className={itemClass}
              key={index}
              onClick={() => {
                setSelectedColorIds(item.ids);
              }}
            >
              <div
                className={classes.colorBlock}
                style={getStyle(item)}
              />
              <span>{websiteEnv.isUnitedKingdom && item.label === 'Multi Color' ? 'Multicolour' : item.label}</span>
            </li>
          );
        })}
      </Slider>
    </div>
  );
};

export default ColorFilter;
